import { Beruf } from '@/domain/mitarbeiter/features/rotationsplan/entities/Beruf';
import { Select } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Select';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import { faCheck, faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function BerufeSelect({
  handleChange,
  value,
}: {
  handleChange: (beruf: Beruf) => void;
  value: Beruf;
}) {
  const { t } = useTranslation();
  const {
    store: {
      data: { berufe },
    },
  } = useRotationsplanFeatureContext();

  return (
    <Select<Beruf>
      selectedOption={value}
      onChange={handleChange}
      drawerLabel={t(
        'domain.mitarbeiter.rotationsplan.rotationsplaene.createRotationsplan.fields.beruf.label',
      )}
      options={berufe}
      renderTriggerContent={(selectedBeruf) =>
        selectedBeruf ? (
          <div className="flex items-center gap-2">
            <FontAwesomeIcon
              color={selectedBeruf.getBorderColor()}
              icon={faCircle}
              className='text-xs'
            />
            <div className="whitespace-nowrap truncate text-sm font-normal">
              {selectedBeruf.name}
            </div>
          </div>
        ) : (
          <div>{t('actions.auswaehlen')}</div>
        )
      }
      renderListItem={(beruf, selectedBeruf) => (
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-2">
            <FontAwesomeIcon color={beruf.getBorderColor()} icon={faCircle} className='text-xs' />
            <div className="whitespace-nowrap truncate text-sm font-normal">
              {beruf.name}
            </div>
          </div>
          {beruf.id === selectedBeruf?.id && (
            <FontAwesomeIcon
              className="text-primary-blue-600"
              icon={faCheck}
            />
          )}
        </div>
      )}
    />
  );
}
